import axios from "axios";
import React, { useEffect, useState } from "react";
import Chart from "../BarChart/Chart";
import DashboardNotes from "../DashboardNotes/DashboardNotes";
import OverviewTable from "../OverviewTable/OverviewTable";
import DashboardTables from "../DashboardTables/DashboardTables";
import "./OverviewDashboard.scss";

export default function OverviewDashboard(props) {
  const { data, dataLoaded } = props;

  const [apiCommoditiesImportData, setApiCommoditiesImportData] = useState([]);
  const [apiCommoditiesExportData, setApiCommoditiesExportData] = useState([]);
  const [apiCountiesData, setApiCountiesData] = useState([]);
  const [apiRegionsData, setApiRegionsData] = useState([]);
  const [countiesApiLoaded, setCountiesApiLoaded] = useState(false);
  const [regionsApiLoaded, setRegionsApiLoaded] = useState(false);
  const [commoditiesImportApiLoaded, setCommoditiesImportApiLoaded] = useState(
    false
  );
  const [commoditiesExportApiLoaded, setCommoditiesExportApiLoaded] = useState(
    false
  );

  useEffect(() => {
    (() => {
      let arr = [];
      axios
        .get(
          "/wp-json/commodities/v1/all",
          {
            params: {
              sort_by: "ImportSTONS",
              sort_dir: "DESC",
              page: 1,
              limit: 5
            }
          }
        )
        .then((res) => res.data)
        .then((data) => {
          const top5 = Object.entries(data)
            .slice(0, 5)
            .map((entry) => entry[1]);
          if (top5) {
            top5.forEach((value) => {
              arr.push({
                name: value.CommodityName,
                importSTONS: value.ImportSTONS,
              });
            });
          }
          setApiCommoditiesImportData(arr);
          setCommoditiesImportApiLoaded(true);
        })
        .catch((e) => e);
    })();

    (() => {
      let arr = [];
      axios
        .get(
          "/wp-json/commodities/v1/all",
          {
            params: {
              sort_by: "ExportSTONS",
              sort_dir: "DESC",
              page: 1,
              limit: 5
            }
          }
        )
        .then((res) => res.data)
        .then((data) => {
          const top5 = Object.entries(data)
            .slice(0, 5)
            .map((entry) => entry[1]);
          if (top5) {
            top5.forEach((value) => {
              arr.push({
                name: value.CommodityName,
                exportSTONS: value.ExportSTONS,
              });
            });
          }
          setApiCommoditiesExportData(arr);
          setCommoditiesExportApiLoaded(true);
        })
        .catch((e) => e);
    })();

    (() => {
      let arr = [];
      axios
        .get("/wp-json/counties/v1/all", {
          params: {
            sort_by: "TotalSTONS",
            sort_dir: "DESC"
          }
        })
        .then((res) => res.data)
        .then((data) => {
          const top10 = Object.entries(data)
            .slice(0, 10)
            .map((entry) => entry[1]);
          if (top10) {
            top10.forEach((value) => {
              arr.push({
                id: value.CountyID,
                urlKey: value.UrlKey,
                name: value.CountyName,
                totalSTONS: value.TotalSTONS,
                totalTEUs: value.TotalTEUs,
              });
            });
          }
          setApiCountiesData(arr);
          setCountiesApiLoaded(true);
        })
        .catch((e) => e);
    })();

    (() => {
      let arr = [];
      axios
        .get("/wp-json/regions/v1/all", {
          params: {
            sort_by: "TotalSTONS"
          }
        })
        .then((res) => res.data)
        .then((data) => {
          data.forEach((value) => {
            arr.push({
              id: value.RegionID,
              urlKey: value.UrlKey,
              name: value.RegionName,
              totalSTONS: value.TotalSTONS,
              totalTEUs: value.TotalTEUs,
            });
          });
          setApiRegionsData(arr);
          setRegionsApiLoaded(true);
        })
        .catch((e) => e);
    })();
  }, []);

  return (
    <div className="dashboard-container">
      <DashboardTables
        apiLoaded={dataLoaded}
        apiData={data}
        showCharts={false}
      />
      <OverviewTable
        data={apiCountiesData}
        title="TOP 10 COUNTIES"
        keyName="COUNTY"
        loaded={countiesApiLoaded}
      />
      <OverviewTable
        data={apiRegionsData}
        title="GEORGIA STATE REGIONS"
        keyName="REGION"
        loaded={regionsApiLoaded}
      />
      <Chart
        data={apiCommoditiesImportData}
        barFill={"#00A79D"}
        direction="IMPORTS"
        loaded={commoditiesImportApiLoaded}
      />
      <Chart
        data={apiCommoditiesExportData}
        barFill={"#04B2D9"}
        direction="EXPORTS"
        loaded={commoditiesExportApiLoaded}
      />
      <DashboardNotes />
    </div>
  );
}